<template>
  <div class="space-y-6">
    <div class="space-y-2">
      <h2 class="text-background-fg/87 text-lg font-medium">
        Today's Summary
      </h2>
      <DashboardReportSummary
        v-if="hasSalesModule"
        :query="salesSummaryQuery"
        label="Sales"
      />
      <DashboardReportSummary
        v-if="hasDonationsModule"
        :query="donationsSummaryQuery"
        label="Donations"
      />
    </div>
    <div
      class="grid auto-rows-fr grid-cols-1 gap-2 lg:grid-cols-2"
    >
      <div class="flex flex-col">
        <h2
          class="text-background-fg/87 mb-2 flex-shrink-0 text-lg font-medium"
        >
          Revenue
        </h2>
        <BaseCard class="relative h-full">
          <div
            class="flex h-full w-full flex-col justify-between"
          >
            <div class="mb-2 h-72 w-full overflow-hidden">
              <template
                v-if="
                  datasets[0] && datasets[0].data.length > 0
                "
              >
                <ChartLineDate
                  id="transactions-cumulative-graph"
                  :labels="labels"
                  :datasets="datasets"
                  :granularity="granularity"
                  is-cumulative
                  :currency="tenant.currency"
                />
              </template>
              <template v-else>
                <BaseInnerLoading />
              </template>
            </div>
            <RouterLink
              :to="{ name: 'reportsTransactions' }"
              class="text-primary flex-shrink-0 text-sm"
            >
              view transactions report
            </RouterLink>
          </div>
        </BaseCard>
      </div>

      <div class="flex flex-col">
        <h2
          class="text-background-fg/87 mb-2 flex-shrink-0 text-lg font-medium"
        >
          Latest Transactions
        </h2>
        <BaseCard class="relative h-full">
          <HomeDashboardTransactionLog />
        </BaseCard>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SummaryReportQuery } from "@/services/reports/retrieveSummaryReport"

const { tenant } = useTenant()
const salesSummaryQuery: SummaryReportQuery = {
  start: DateFns.format(new Date(), "yyyy-MM-dd"),
  end: DateFns.format(new Date(), "yyyy-MM-dd"),
  sources: ["sale"],
}

const donationsSummaryQuery: SummaryReportQuery = {
  start: DateFns.format(new Date(), "yyyy-MM-dd"),
  end: DateFns.format(new Date(), "yyyy-MM-dd"),
  sources: ["donation"],
}

const { hasSalesModule, hasDonationsModule } = useTenant()
const { data } = useTransactionReport()

const rawDatasets = computed(() =>
  data.value?.dataset ? [data.value.dataset] : []
)

const granularity = computed(() => data.value?.granularity)

const labels = computed(
  () =>
    rawDatasets.value?.[0]?.map(({ start, end }) => ({
      start,
      end,
    })) || []
)

const datasets = computed(() =>
  rawDatasets.value.map((rawDataset) => {
    const colorVariableName = "--color-primary"
    const colorVariable = colorVariableName
      ? useCssVar(colorVariableName).value
      : undefined
    const color = colorVariable
      ? `rgb(${colorVariable})`
      : undefined
    return {
      label: "",
      data: rawDataset?.map(({ value }) => value) || [],
      color: color,
    }
  })
)
</script>
